import { IEmployee } from "./IEmployee";
import { IUser } from "./IUser";
import { IUserGroup } from "./IUserGroup";

export class FullUser implements IUser {
  username: string;
  email: string | undefined;
  name: string | null;
  password: string;
  userGroups: IUserGroup[];
  allowedModules: string[];
  allAllowedModules: string[];
  userGroupNames: string[];
  employee?: IEmployee;

  constructor(
    name: string | null,
    username: string,
    email: string | undefined,
    userGroups: IUserGroup[],
    allowedModules: string[],
    userGroupNames: string[],
    employee: IEmployee | undefined
  ) {
    this.name = name;
    this.username = username;
    this.email = email;
    this.password = "*******";
    this.userGroups = userGroups;
    this.allowedModules = allowedModules;
    this.allAllowedModules = this.getAllAllowedModules();
    this.userGroupNames = userGroupNames;
    this.employee = employee;
  }

  getAllAllowedModules(): string[] {
    return this.allowedModules;
  }

  isModuleAllowed(module: string) {
    return this.getAllAllowedModules().includes(module);
  }

  isInGroup(groupName: string) {
    return this.userGroupNames.includes(groupName);
  }

  isInAnyGroup(groupNames: string[]) {
    return groupNames.some(groupName => this.isInGroup(groupName));
  }

}
